export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";